function formatNavCount(count: number): string {
  if (count > 99) return "99+";
  return String(count);
}

/** Navbar icon: calendar outline with upcoming count inside the grid (Fresha-style). */
function BookingsNavCalendarIcon({ count }: { count: number }) {
  const display = count > 0 ? formatNavCount(count) : "";

  return (
    <svg
      className="size-[22px]"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M8 2v4" />
      <path d="M16 2v4" />
      <rect width="18" height="18" x="3" y="4" rx="2" />
      <path d="M3 10h18" />
      {display ? (
        <text
          x="12"
          y="16.75"
          textAnchor="middle"
          dominantBaseline="middle"
          fill="currentColor"
          stroke="none"
          fontSize="9"
          fontWeight="700"
          fontFamily="var(--font-mono)"
        >
          {display}
        </text>
      ) : null}
    </svg>
  );
}

/** Drawer / menu row: brand orange pill with white count on the trailing edge. */
function BookingsUpcomingCountBadge({ count }: { count: number }) {
  if (count <= 0) return null;

  return (
    <span
      className="ml-auto flex min-h-[22px] min-w-[22px] shrink-0 items-center justify-center rounded-full bg-electric-700 px-1.5 text-[12px] font-bold leading-none tabular-nums text-white"
      aria-hidden="true"
    >
      {formatNavCount(count)}
    </span>
  );
}

export { BookingsNavCalendarIcon, BookingsUpcomingCountBadge };
